import React,{ useEffect,useState } from "react";
import "./App.css";
import logo from "./logo.svg";
import qr from "./qr.svg";

import { sideMenu } from "./sideMenu";
import { MenuItem } from './MultiLevel';
// import MobileMenu from './mobile/MobileMenu'
function App() {
   const [orentation,setOrentation] = useState((window.mob || window.isipad) && window.innerHeight > window.innerWidth ? 90 : 0)
   const [skin_menu,setskin_menu] = useState(false);
   const mobIpadPotrait = window.mob && orentation == 90 || window.isipad && orentation == 90;
   const handleClick = (divname) => {

      const collection = document.getElementsByClassName("mob_skin_icon");
      for (let i = 0; i < collection.length; i++) {
         collection[i].classList.remove('active');
      }
      document.getElementById(divname).classList.add('active');
      window.changeSkin(divname);
   }
   const skin_menu_show = () => {

      if (skin_menu) {
         const mob_skin_icon = document.getElementsByClassName("mob_skin_icon");
         for (let i = 0; i < mob_skin_icon.length; i++) {
            mob_skin_icon[i].style.display = 'none';
         }
         document.getElementById("mob_skin_header_name").style.display = 'inline';
         document.getElementById("skin_type").style.display = 'none';
         document.getElementById("icon_skin").style.height = '90%';
         setskin_menu(false);
      } else {
         if (window.selectedMenu.cameraType != 'exterior') { window.fadeIn(window.reset) }
         else { window.reset() }
         window.GotoPosInTimeNamedValue('Reset_View_F14',function () {
            window.scene.groupApplyState('Ref_ON');
            window.scene.groupApplyState("Skin_off");
            if (document.getElementById("skin_type")) {

               document.getElementById("skin_type").value = "Skin_Full";
            }
            window.selectedMenu.cameraType = 'exterior';
            setTimeout(window.fadeOut,600)
         });
         if (window.mob || window.isipad || window.innerWidth < 818 || window.innerHeight < 818) {

            window.currentPosition = '';
            const collection = document.getElementsByClassName("menu");
            for (let i = 0; i < collection.length; i++) {
               collection[i].classList.remove('active');
            }
            const arrow = document.getElementsByClassName("content1");
            for (let i = 0; i < arrow.length; i++) {

               arrow[i].style.maxHeight = null

            }
         }

         const mob_skin_icon = document.getElementsByClassName("mob_skin_icon");
         for (let i = 0; i < mob_skin_icon.length; i++) {
            mob_skin_icon[i].style.display = 'block';
         }
         document.getElementById("mob_skin_header_name").style.display = 'none';
         document.getElementById("skin_type").style.display = 'block';
         document.getElementById("icon_skin").style.height = '65%';
         setskin_menu(true);
      }
   }
   useEffect(() => {
      window.addEventListener("orientationchange",event => {
         if (window.innerHeight > window.innerWidth) {
            setOrentation(0);

         } else {
            setOrentation(90);

         }
      });
   },[]);

   return (
      <>
         <div id="leftMenu">
            {<div name="skin_type" id="skin_type" style={{ fontSize: '16px',display: 'none' }}>
               <button type='button' style={{ background: 'transparent',color: 'white',border: 'none' }} id="Full" onClick={window.Skin_Full} className='active'>Full Wrap</button>
               <button type='button' style={{ background: 'transparent',color: 'white',border: 'none',borderLeft: '1px solid' }} id="Top" onClick={window.Skin_Top}>Top Cover</button>
            </div>}
            <div className="logo_div">
               <img className="" alt="" src={logo} />
            </div>
            {!!mobIpadPotrait &&  <div className="mob_skins_menu">

               <div className="skin_header" onClick={skin_menu_show}>
                  <img className='' id="icon_skin" src={sideMenu.find(element => element.id == 'Skins').icon} />
                  <span id="mob_skin_header_name" style={{ marginLeft: '15px',color: '#45d62c',position: 'relative',top: '-6px' }}>Skins</span>
               </div>

               {sideMenu.find(element => element.id == 'Skins').items.map((item,key) =>
                  <div style={{ display: 'none' }} className='mob_skin_icon' key={key} id={item.id} onClick={() => { handleClick(item.id) }}>
                     <img className='' src={item.icon} />
                  </div>
               )}
            </div>}
            <div className="main_menu">
               {sideMenu.map((item,key) =>
                  <MenuItem setskin_menu={setskin_menu} key={key} item={item} />
               )}

            </div>
            {(!window.mob && !window.isipad) && <div className="QR_div" id='qrCode'>
               <h5>View the Blade 14 in your environment</h5>
               <img className="" alt="" src={qr} />
            </div>}
         </div>
      </>
   );
}


export default App;
